import { render, staticRenderFns } from "./Hosting.vue?vue&type=template&id=65bdc7a2&"
import script from "./Hosting.vue?vue&type=script&lang=js&"
export * from "./Hosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports